/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetRemedyResponse } from '../models/GetRemedyResponse';
import type { VastuRequest } from '../models/VastuRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VastuControllerService {
    /**
     * @param propertyId
     * @param requestBody Request body for direction-related information
     * @param tenantId
     * @returns any OK
     * @throws ApiError
     */
    public static vastuControllerUpdateVastuRemedy(
        propertyId: string,
        requestBody: VastuRequest,
        tenantId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v0/api/vastu-remedy/{propertyId}',
            path: {
                'propertyId': propertyId,
            },
            query: {
                'tenantId': tenantId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param remedyId
     * @returns GetRemedyResponse Get remedy response
     * @throws ApiError
     */
    public static vastuControllerGetRemedyById(
        remedyId: string,
    ): CancelablePromise<GetRemedyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v0/api/vastu-remedy/{remedyId}',
            path: {
                'remedyId': remedyId,
            },
        });
    }
    /**
     * @param direction
     * @param limit
     * @param offset
     * @returns any Return value of VastuController.getDirectionDetails
     * @throws ApiError
     */
    public static vastuControllerGetDirectionDetails(
        direction?: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/vastu-details-by-direction',
            query: {
                'direction': direction,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * @param remedyId
     * @param field
     * @param requestBody Edited content for the specified field
     * @returns any Edited Remedy Response
     * @throws ApiError
     */
    public static vastuControllerEditRemedy(
        remedyId: string,
        field?: string,
        requestBody?: {
            /**
             * Updated content for the field
             */
            content: Record<string, (string | Array<string> | Record<string, any>)>;
        },
    ): CancelablePromise<{
        id?: string;
        /**
         * ID of the original remedy
         */
        originalRemedyId?: string;
        observations?: {
            entrance?: Array<string>;
            toilet?: Array<string>;
            kitchen?: Array<string>;
        };
        recommendations?: {
            entrance?: Array<string>;
        };
        remedies?: {
            toilet?: Array<string>;
            kitchen?: Array<string>;
        };
        isEditable?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/vastu-remedy/{remedyId}/edit',
            path: {
                'remedyId': remedyId,
            },
            query: {
                'field': field,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody Request body for direction-related information
     * @param propertyId
     * @param tenantId
     * @returns any OK
     * @throws ApiError
     */
    public static vastuControllerCheckVastuRemedy(
        requestBody: VastuRequest,
        propertyId?: string,
        tenantId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/vastu-remedy',
            query: {
                'propertyId': propertyId,
                'tenantId': tenantId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
